/* TypeScript file generated from Group.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as GroupJS from './Group.res.js';

import type {alignItems as StyleX_alignItems} from '../../../src/externals/StyleX.gen';

import type {t as Spaces_t} from '../../../src/resources/theme/Spaces.gen';

export type props<children,grid,wrap,grow,stretch,spaceX,spaceY,alignY> = {
  readonly children: children; 
  readonly grid?: grid; 
  readonly wrap?: wrap; 
  readonly grow?: grow; 
  readonly stretch?: stretch; 
  readonly spaceX?: spaceX; 
  readonly spaceY?: spaceY; 
  readonly alignY?: alignY
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly grid?: string[]; 
  readonly wrap?: boolean; 
  readonly grow?: boolean; 
  readonly stretch?: boolean; 
  readonly spaceX?: Spaces_t; 
  readonly spaceY?: Spaces_t; 
  readonly alignY?: StyleX_alignItems
}> = GroupJS.make as any;
